export default __webpack_public_path__ + "static/media/logo.0ac4c7fc.svg";